"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _H = require("./H1");
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var H2 = /*#__PURE__*/
(0, _reactEmotion.default)('h2', {
  target: "eo7gl9j0"
})(_base.default, ";", _font.default, ";", _H.text, ";font-size:", function (props) {
  return props.fontSize || '2.25rem';
}, ";line-height:", function (props) {
  return props.lineHeight || '2.75rem';
}, ";font-weight:", function (props) {
  return props.fontWeight || 300;
}, ";text-align:", function (props) {
  return props.center ? 'center' : 'inherit';
}, ";", (0, _mediaQueries.default)('md'), "{font-size:1.375rem;line-height:2.25rem;}");
var _default = H2;
exports.default = _default;